import { reportConstants } from '../constants';
import { reportService } from '../services';
import { loaderMaskActions } from '.';
import { handleErrors } from '../../utils';

export const reportActions = {
	getExecutedReports,

	getExecReportsFromURIQuery,
	setExecReportsParams,

	loadPipelinesByPipelineId,

	getConfiguredReports,
	expandRow,
	setActiveRow,
	clearReports,

	toggleSelectAll,
	setExecReportSelection,

	toggleReportsActiveTab,

	setSelectedNewReportCustomer,
	
	toggleModalAddReportWizard,
	setWizardSelectedReportId,
	setWizardSelectedReport,

	setSelectedReportEdit,
	setSelectedReportEditIsActive,
	setSelectedReportEditIsInternalUse,
	setDefaultReportPage,

	setHandleGridReloadCallBack
};


function setHandleGridReloadCallBack(handleGridReloadCallBack) {
	return { type: reportConstants.SET_HANDLE_GRID_RELOAD_CALLBACK, handleGridReloadCallBack };
}

function setDefaultReportPage(defaultReportPage) {
	return { type: reportConstants.SET_DEFAULT_REPORT_PAGE, defaultReportPage };
}

function setSelectedReportEdit(selectedReportEdit) {
	return { type: reportConstants.SET_SELECTED_REPORT_EDIT, selectedReportEdit };
}

function setSelectedReportEditIsActive(selectedReportEditIsActive) {
	return { type: reportConstants.SET_SELECTED_REPORT_EDIT_IS_ACTIVE, selectedReportEditIsActive };
}

function setSelectedReportEditIsInternalUse(selectedReportEditIsInternalUse) {
	return { type: reportConstants.SET_SELECTED_REPORT_EDIT_IS_INTERNAL_USE, selectedReportEditIsInternalUse };
}

function setSelectedNewReportCustomer(selectedNewReportCustomer) {
	return { type: reportConstants.SET_SELECTED_NEW_REPORT_CUSTOMER, selectedNewReportCustomer };
}

function setWizardSelectedReport(selectedReport) {
	return { type: reportConstants.TOGGLE_WIZARD_SELECTED_REPORT, selectedReport };
}

function setWizardSelectedReportId(selectedReportId) {
	return { type: reportConstants.TOGGLE_WIZARD_SELECTED_REPORT_ID, selectedReportId };
}

function toggleModalAddReportWizard(modalAddReportWizard) {
	return { type: reportConstants.TOGGLE_MODAL_ADD_REPORT_WIZARD, modalAddReportWizard };
}

function toggleReportsActiveTab(tab) {
	return { type: reportConstants.TOGGLE_REPORTS_ACTIVE_TAB, tab };
}

function toggleSelectAll(pageItemCount) {
	return { type: reportConstants.TOGGLE_EXEC_REPORTS_SELECT_ALL, pageItemCount };
}

function setExecReportSelection(pipelineInstanceId) {
	return { type: reportConstants.TOGGLE_EXEC_REPORTS_SELECTION, pipelineInstanceId };
}

function getExecutedReports(params) {
	return (dispatch) => {
		dispatch(loaderMaskActions.show('Loading reports...'));
		dispatch(request());
		return reportService.getExecutedReports(params).then(
			(data) => {
				dispatch(loaderMaskActions.hide(''));
				return dispatch(success(data.Data, data.Count, data.TotalPages, data.TotalCount));
			},
			(error) => {
				handleErrors(error, dispatch);
				dispatch(loaderMaskActions.hide(''));
				return dispatch(failure(error));
			}
		);
	};

	function request() {
		return { type: reportConstants.GETALL_REQUEST };
	}

	function success(reports, Count, TotalPages, TotalCount) {
		return {
			type: reportConstants.GET_EXECUTEDREPORTS_SUCCESS,
			reports,
			Count,
			TotalPages,
			TotalCount
		};
	}

	function failure(error) {
		return { type: reportConstants.GETALL_FAILURE, error };
	}
}

function getExecReportsFromURIQuery(params) {
	return (dispatch) => {
		dispatch(loaderMaskActions.show('Loading reports...'));
		reportService.getExecutedReports(params).then(
			(data) => {
				dispatch(success(data.Data, data.Count, data.TotalPages, data.TotalCount, params));
				dispatch(loaderMaskActions.hide(''));
			},
			(error) => {
				handleErrors(error, dispatch);
				dispatch(loaderMaskActions.hide(''));
				dispatch(failure(error));
			}
		);
	};

	function success(reports, Count, TotalPages, TotalCount, params) {
		return {
			type: reportConstants.GET_EXECUTEDREPORTS_URI_SUCCESS,
			reports,
			Count,
			TotalPages,
			TotalCount,
			params
		};
	}

	function failure(error) {
		return { type: reportConstants.GETALL_FAILURE, error };
	}
}

function setExecReportsParams(paramName, paramValue) {
	return {
		type: reportConstants.SET_EXEC_REPORTS_PARAMS,
		paramName,
		paramValue
	};
}

function loadPipelinesByPipelineId(pipelineid, index, customerId) {
	return (dispatch) => {
		let params = {
			pipelineid: pipelineid
		};
		if (customerId) params['CustomerId'] = customerId;
		reportService.loadPipelinesByPipelineId(params).then(
			(data) => dispatch(success(data.Data, index)),
			(error) => {
				handleErrors(error, dispatch);
				dispatch(failure(error));
			}
		);
	};

	function success(pipelines, index) {
		return { type: reportConstants.UPDATE_REPORTS_PIPELINES, pipelines, index };
	}

	function failure(error) {
		return { type: reportConstants.GETALL_FAILURE, error };
	}
}

function getConfiguredReports(params) {
	return (dispatch) => {
		//dispatch(loaderMaskActions.show('Loading reports...'));
		//dispatch(request());
		reportService.getConfiguredReports(params).then(
			(data) => {
				//dispatch(loaderMaskActions.hide(''));
				dispatch(success(data.Data, data.TotalPages));
			},
			(error) => {
				handleErrors(error, dispatch);
				//dispatch(loaderMaskActions.hide(''));
				dispatch(failure(error));
			}
		);
	};

    function request() {
		return { type: reportConstants.GET_CONFIGUREDREPORTS_REQUEST };
	}

	function success(reports, TotalPages) {
		return {
			type: reportConstants.GET_CONFIGUREDREPORTS_SUCCESS,
			reports,
			TotalPages
		};
	}

	function failure(error) {
		return { type: reportConstants.GET_CONFIGUREDREPORTS_FAILURE, error };
	}
}

function expandRow(reportsName, rowIndex) {
	return { type: reportConstants.EXPAND_ROW, reportsName, rowIndex };
}

function setActiveRow(reportsName, rowIndex) {
	return { type: reportConstants.SET_ACTIVE_ROW, reportsName, rowIndex };
}

function clearReports() {
	return { type: reportConstants.CLEAR_REPORTS };
}
